import { Grid } from '@mui/joy';
import { LibraryFileList } from './MainLibraryContent';

export const LibraryPage = () => {
  return (
    <Grid container>
      <Grid xs={0} lg={2}></Grid>
      <Grid xs={12} lg={8} padding={'1rem'}>
        <LibraryFileList />
      </Grid>
    </Grid>
  );
};
